import { MarketingService } from '../services/marketing.service';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';

export class MarketingModel {

    private _type:string = 'mobile';
    private _typeSearch:string = 'mobile';
    private _male:boolean = false;
    private _female:boolean = false;
    private _looser:boolean = false;

    private _depensed:number = null;
    private _clientSince: any;
    private _serviceSince: any;
    private _serviceNotSince: any;

    private _interestedRun:boolean = false;
    private _interestedAccessory: boolean = false;
    private _interestedService: boolean  = false;
    private _interestedVtt: string       = 'false';
    private _interestedAubonne: boolean  = false;
    private _interestedGeneve: boolean  = false;
    private _interestedCyclocross: boolean  = false;

    private _currentCode  = '';
    private _currentModel = '';
    private _currentBrand = '';

    private _listBrand: string[] = [];
    private _listModel: string[] = [];
    private _listCode: string[] = [];

    private _name:string = '';
    private _errors: any[] = [];
    private _message:string = '';

    private _letterSpeed:boolean         = true;
    private _file:any = null;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public _marketingService: MarketingService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    modelChange(){

    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validateSMS(): boolean {

        let validator = new ValidatorService();
        validator
            .addField(this._name, 'name', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._message, 'message', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 1, max: 1000}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    public validateLetter(): boolean {

        let validator = new ValidatorService();
        validator
            .addField(this._name, 'name', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ])
            .addField(this._file, 'file', EvalidatorRequire.Require, [
                {fn: validator.file, options: {size: 4000000, type: 'application/pdf'}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //************** METHOD ***************
    //*************************************

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************
    get type(): string {
        return this._type;
    }

    set type(value: string) {
        this._type = value;
    }

    get typeSearch(): string {
        return this._typeSearch;
    }

    set typeSearch(value: string) {
        this._typeSearch = value;
    }

    get male(): boolean {
        return this._male;
    }

    set male(value: boolean) {
        this._male = value;
    }

    get female(): boolean {
        return this._female;
    }

    set female(value: boolean) {
        this._female = value;
    }

    get looser(): boolean {
        return this._looser;
    }

    set looser(value: boolean) {
        this._looser = value;
    }

    get depensed(): number {
        return this._depensed;
    }

    set depensed(value: number) {
        this._depensed = value;
    }

    get clientSince(): any {
        return this._clientSince;
    }

    set clientSince(value: any) {
        this._clientSince = value;
    }

    get serviceSince(): any {
        return this._serviceSince;
    }

    set serviceSince(value: any) {
        this._serviceSince = value;
    }

    get serviceNotSince(): any {
        return this._serviceNotSince;
    }

    set serviceNotSince(value: any) {
        this._serviceNotSince = value;
    }

    get interestedRun(): boolean {
        return this._interestedRun;
    }

    set interestedRun(value: boolean) {
        this._interestedRun = value;
    }

    get interestedAccessory(): boolean {
        return this._interestedAccessory;
    }

    set interestedAccessory(value: boolean) {
        this._interestedAccessory = value;
    }

    get interestedService(): boolean {
        return this._interestedService;
    }

    set interestedService(value: boolean) {
        this._interestedService = value;
    }

    get interestedVtt(): string {
        return this._interestedVtt;
    }

    set interestedVtt(value: string) {
        this._interestedVtt = value;
    }

    get interestedAubonne(): boolean {
        return this._interestedAubonne;
    }

    set interestedAubonne(value: boolean) {
        this._interestedAubonne = value;
    }

    get interestedGeneve(): boolean {
        return this._interestedGeneve;
    }

    set interestedGeneve(value: boolean) {
        this._interestedGeneve = value;
    }

    get interestedCyclocross(): boolean {
        return this._interestedCyclocross;
    }

    set interestedCyclocross(value: boolean) {
        this._interestedCyclocross = value;
    }

    get currentCode(): string {
        return this._currentCode;
    }

    set currentCode(value: string) {
        this._currentCode = value;
    }

    get currentModel(): string {
        return this._currentModel;
    }

    set currentModel(value: string) {
        this._currentModel = value;
    }

    get currentBrand(): string {
        return this._currentBrand;
    }

    set currentBrand(value: string) {
        this._currentBrand = value;
    }

    get listBrand(): string[] {
        return this._listBrand;
    }

    set listBrand(value: string[]) {
        this._listBrand = value;
    }

    get listModel(): string[] {
        return this._listModel;
    }

    set listModel(value: string[]) {
        this._listModel = value;
    }

    get listCode(): string[] {
        return this._listCode;
    }

    set listCode(value: string[]) {
        this._listCode = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get errors(): any[] {
        return this._errors;
    }

    set errors(value: any[]) {
        this._errors = value;
    }

    get message(): string {
        return this._message;
    }

    set message(value: string) {
        this._message = value;
    }

    get letterSpeed(): boolean {
        return this._letterSpeed;
    }

    set letterSpeed(value: boolean) {
        this._letterSpeed = value;
    }

    get file(): any {
        return this._file;
    }

    set file(value: any) {
        this._file = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/marketing.model.ts